import script from "./VideoLayer.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoLayer.vue?vue&type=script&setup=true&lang=js"

import "./VideoLayer.vue?vue&type=style&index=0&id=3fd8b84d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fd8b84d"]])

export default __exports__